import { Calculator, ArrowUpRight } from "lucide-react";

const TRADIE_CALC_URL = "https://calc.nztaxation.nz/tools/tax";

export default function FreeCalculator() {
  return (
    <section
      id="free-calculator"
      className="py-16 md:py-24"
      data-testid="free-calculator-section"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <a
          href={TRADIE_CALC_URL}
          target="_blank"
          rel="noreferrer"
          className="group block relative overflow-hidden border border-[#0A192F] bg-[#0A192F] text-white"
          data-testid="free-calculator-card"
        >
          {/* Ambient gold grid accents */}
          <div
            aria-hidden
            className="absolute -top-24 -right-24 w-72 h-72 bg-[#C9A349]/10 blur-3xl"
          />
          <div
            aria-hidden
            className="absolute -bottom-24 -left-24 w-72 h-72 bg-[#C9A349]/5 blur-3xl"
          />

          <div className="relative grid md:grid-cols-12 gap-8 md:gap-12 p-8 md:p-12 items-center">
            {/* Left — copy */}
            <div className="md:col-span-7">
              <div className="flex items-center gap-3">
                <span className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.22em] font-bold text-[#C9A349]">
                  <Calculator className="w-4 h-4" /> Free tool · no signup
                </span>
              </div>

              <h2 className="mt-4 font-heading font-black text-3xl md:text-5xl leading-[1.05] tracking-tight">
                Tradies — price the job in seconds.
                <br className="hidden md:block" />
                <span className="text-[#C9A349]"> Know your tax before you invoice.</span>
              </h2>

              <p className="mt-5 text-slate-300 text-base md:text-lg max-w-2xl leading-relaxed">
                A workshop-grade calculator built for sparkies, chippies, plumbers and sole
                traders. Quote with 15% GST baked in, estimate your PAYE on take-home, and
                export a clean invoice — all without a spreadsheet.
              </p>

              <ul className="mt-6 flex flex-wrap gap-x-6 gap-y-2 text-xs uppercase tracking-[0.18em] font-bold text-slate-300">
                <li className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-[#C9A349]" /> 15% GST baked in
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-[#C9A349]" /> 2025 IRD brackets
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-[#C9A349]" /> Invoice export
                </li>
                <li className="flex items-center gap-2">
                  <span className="w-1.5 h-1.5 bg-[#C9A349]" /> Runs in your browser
                </li>
              </ul>
            </div>

            {/* Right — CTA card */}
            <div className="md:col-span-5 md:justify-self-end w-full md:max-w-sm">
              <div className="border border-[#C9A349]/40 bg-black/20 backdrop-blur p-6 md:p-7">
                <div className="text-[11px] uppercase tracking-[0.22em] font-bold text-[#C9A349]">
                  Sample quote
                </div>
                <dl className="mt-4 text-sm space-y-2 text-slate-200">
                  <div className="flex items-center justify-between">
                    <dt>Labour 8h @ $85</dt>
                    <dd>$680.00</dd>
                  </div>
                  <div className="flex items-center justify-between">
                    <dt>Materials</dt>
                    <dd>$312.40</dd>
                  </div>
                  <div className="flex items-center justify-between">
                    <dt>Markup 15%</dt>
                    <dd>$148.86</dd>
                  </div>
                  <div className="flex items-center justify-between border-t border-white/10 pt-2 mt-2">
                    <dt>GST 15%</dt>
                    <dd className="text-[#C9A349]">$171.19</dd>
                  </div>
                  <div className="flex items-center justify-between pt-2 mt-2 border-t-2 border-[#C9A349]">
                    <dt className="font-heading font-black text-base">Total</dt>
                    <dd className="font-heading font-black text-base">$1,312.45</dd>
                  </div>
                </dl>

                <div className="mt-6 inline-flex items-center gap-2 bg-[#C9A349] text-[#0A192F] px-5 py-3 font-heading font-bold text-sm uppercase tracking-[0.15em] w-full justify-center group-hover:bg-white transition-colors">
                  Try the calculator
                  <ArrowUpRight className="w-4 h-4" />
                </div>
                <p className="mt-3 text-[11px] text-slate-400 text-center">
                  Opens in a new tab · nztaxation.nz free tool
                </p>
              </div>
            </div>
          </div>

          {/* subtle animated corner tag */}
          <div
            aria-hidden
            className="absolute top-0 left-0 bg-[#C9A349] text-[#0A192F] text-[10px] font-bold uppercase tracking-[0.22em] px-3 py-1"
          >
            New · Free
          </div>
        </a>
      </div>
    </section>
  );
}
